import { FileError } from 'react-dropzone'

import { ERROR_CODE_MESSAGES, IMAGE_FILE_TYPES } from '../../constants'
import { ErrorCode, TrackedFile } from '../../types'

export function duplicateFileValidator({
  file,
  files,
}: {
  file: File
  files: TrackedFile[]
}): FileError | FileError[] | null {
  const duplicateFile = files.find((f) => f.file?.name === file.name)

  if (duplicateFile) {
    return {
      code: ErrorCode.DUPLICATE_FILE,
      message: ERROR_CODE_MESSAGES[ErrorCode.DUPLICATE_FILE],
    }
  }

  return null
}

export function getIsUnsupportedImageType(file: File): boolean {
  const fileName = file.name
  const extension = fileName.slice(fileName.lastIndexOf('.')).toLowerCase()
  const isExtensionValid = IMAGE_FILE_TYPES.includes(extension)

  const mimeType = file.type
  const mimeSubtype = mimeType.startsWith('image/') ? mimeType.split('/')[1] : ''
  const isMimeValid = IMAGE_FILE_TYPES.includes(`.${mimeSubtype}`)

  return !(isExtensionValid || isMimeValid)
}
